enum OrderLockStatus {
  Unlocked = 0,
  Locked = 1,
  LockedByExternalApp = 2
}

export default OrderLockStatus;
